import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H4Text } from '@prisjakt/ui/text/variants';
import { pushEvent } from 'src/client/data-layer';
import { useLocalStorage } from 'src/hooks/use-localstorage';
import { IOptions, IQuestion, Questions } from './questions';

import { AvailableQuestions, QuestionsEnum } from './types';

import { FeedbackImage } from './styles';

type Props = {
  page: string;
  visibleQuestions?: AvailableQuestions[];
};

export const UxLiteQuestions = ({
  page,
  visibleQuestions = [QuestionsEnum.EASE, QuestionsEnum.USEFUL],
}: Props) => {
  const { t, market } = useAppContext();
  const [_, setLocalStorage] = useLocalStorage(`pj:${page}UXFeedbackTime`, 0);

  const options: IOptions[] = [
    { value: 1, label: t('feedback', 'uup.answer-label-1') },
    { value: 2, label: '' },
    { value: 3, label: '' },
    { value: 4, label: '' },
    { value: 5, label: t('feedback', 'uup.answer-label-6') },
  ];

  const questions: IQuestion[] = visibleQuestions.map(question => {
    return {
      name: question,
      question: t('feedback', `uup.${question}-question`),
      score: 0,
    };
  });

  const handleSubmit = (answeredQuestions: IQuestion[]) => {
    let invalidOp = false;
    const feedbackData: { ease?: number; useful?: number; page: string } = {
      page,
    };

    answeredQuestions.forEach(question => {
      if (typeof question.score !== 'number') {
        invalidOp = true;
        return;
      }
      switch (question.name) {
        case QuestionsEnum.EASE:
          feedbackData.ease = question.score;
          break;
        case QuestionsEnum.USEFUL:
          feedbackData.useful = question.score;
          break;
        default:
          invalidOp = true;
          break;
      }
    });

    if (invalidOp) {
      return;
    }

    // Push the score to GTM and Amplitude where it will be stored
    pushEvent('UXLiteFeedbackSubmitted', feedbackData);
    setLocalStorage(new Date().valueOf());
  };

  const thankYouScreen = (
    <>
      <FeedbackImage
        src={`${market.cdn}/g/rfe/illustrations/thumb-up-144px.png`}
        alt=""
      />
      <H4Text>{t('feedback', 'uup.thank-you')}</H4Text>
    </>
  );

  return (
    <Questions
      questions={questions}
      options={options}
      thankYouScreen={thankYouScreen}
      onSubmit={answeredQuestions => handleSubmit(answeredQuestions)}
      randomized
      submitOnAnswer
    />
  );
};
